import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { MedicationLableProps, OrderStatusCode } from '../interface/interface';

const MedicationLabelCheckModal = (props: MedicationLableProps) => {
  const handleTotalQty = (value: string) => {
    props.setTotalQty(value);
    props.setTotalQtyAlert(
      Boolean(value !== '' && Number(value) !== props?.itemCount),
    );
  };

  return (
    <>
      <div className="mt-4 flex justify-between">
        <p>
          {props.currentStatusId === OrderStatusCode.DISPENSING
            ? 'Total Labels Printed'
            : 'Total Products Packed'}
        </p>
        <input
          type="number"
          name="Lable Count"
          id="lable-count"
          className={`text-sm font-regular border rounded-md p-2 w-1/4`}
          placeholder="Total Labels"
          onChange={(e) => handleTotalQty(e.target.value)}
          onKeyDown={(e) => {
            if (
              e.key === 'Enter' &&
              !e.repeat &&
              e.currentTarget.value !== '' &&
              Number(e.currentTarget.value) === props?.itemCount
            ) {
              e.preventDefault();
              props.onEnter?.();
            }
          }}
          autoFocus
        />
      </div>
      {props.isQtyAlert ? (
        <div className="rounded-md bg-blue-50 p-3 mt-3">
          <div className="flex">
            <div className="shrink-0 me-3">
              <InformationCircleIcon
                aria-hidden="true"
                className="size-5 text-blue-400"
              />
            </div>
            <div className="text-sm text-primary-blue-500">
              <p>
                {`The quantity you've entered is ${Number(props.totalQty) < Number(props?.itemCount) ? 'lesser' : 'greater'} than the total
              quantity.`}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default MedicationLabelCheckModal;
